<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  methods:{
    getRem(pwidth, prem) {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / pwidth) * prem + "px";
    }
  },
  created(){
      this.getRem(1920, 100);
      window.onresize = () => {
        this.getRem(1920, 100);
      };
  },
  components: {},
};
</script>

<style>
</style>
